import './public-path.js'
// babel-preset-env will replace this with just the polyfills we need based on the browsers we support
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'drag-drop-touch'

import React from 'react'
import ReactDOM from 'react-dom/client'
import {App} from './App.tsx'
import {launchParams} from './launchParams.js'
import {TanStackProvider} from './initTanstackQuery.tsx'

const rootEl = document.getElementById('root')

// Suppress warnings about deprecated methods in development
// These are known issues and will be fixed in the very near future
// TODO: Remove this once React 18 support is complete
if (process.env.NODE_ENV === 'development') {
  const originalConsoleError = console.error

  // eslint-disable-next-line immutable/no-mutation
  console.error = function (...args) {
    const message = args[0] instanceof Error ? args[0].message : args[0]
    if (typeof message === 'string' && /(React 18|will be removed)/i.test(message)) {
      return
    }
    originalConsoleError.apply(console, args)
  }
}

let sessionStorage = null
let localStorage = null
try {
  sessionStorage = window.sessionStorage
  localStorage = window.localStorage
} catch {
  // Crossdomain and 3rd-party cookies disabled
}

// Initialize the store with launch params
const {
  accessToken,
  assignmentId,
  courseWorkflowState,
  currentUser,
  highContrast,
  itemBanksScope,
  launchUrl,
  platform,
  returnToUrl,
  rldbLaunch,
  rcsHost,
  rcsJwt,
  contextType,
  canvasContextId,
  canvasLocalContextId,
  canvasToolId,
  userCanvasId,
  canvasHost,
  moduleLaunch,
  canvasAssignmentId,
  timeZone,
  restrictQuantitativeData,
  gradingScheme,
  launchToken,
  readOnly,
  decimalSeparator,
  thousandSeparator,
  aiQuizGeneration,
  assignmentAvailability,
} = launchParams(self.location.search, sessionStorage, localStorage)

if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    <TanStackProvider>
      <App
        accessToken={accessToken}
        assignmentId={assignmentId}
        courseWorkflowState={courseWorkflowState}
        currentUser={currentUser}
        highContrast={highContrast}
        itemBanksScope={itemBanksScope}
        launchUrl={launchUrl}
        platform={platform}
        returnToUrl={returnToUrl}
        rldbLaunch={rldbLaunch}
        rcsHost={rcsHost}
        rcsJwt={rcsJwt}
        contextType={contextType}
        canvasContextId={canvasContextId}
        canvasLocalContextId={canvasLocalContextId}
        canvasToolId={canvasToolId}
        userCanvasId={userCanvasId}
        canvasHost={canvasHost}
        moduleLaunch={moduleLaunch}
        canvasAssignmentId={canvasAssignmentId}
        timeZone={timeZone}
        restrictQuantitativeData={restrictQuantitativeData}
        gradingScheme={gradingScheme}
        launchToken={launchToken}
        readOnly={readOnly}
        decimalSeparator={decimalSeparator}
        thousandSeparator={thousandSeparator}
        aiQuizGeneration={aiQuizGeneration === 'true' || aiQuizGeneration === true}
        assignmentAvailability={assignmentAvailability}
      />
    </TanStackProvider>,
  )
}
